<script>
export default {
  name: 'Pixel',
  props: {
    propSource: {type: String, required: true},
  },
  computed: {
    pixelUrl() {
      let apiUrl = process.env.VUE_APP_API_URL;
      if (typeof apiUrl !== 'string')
        apiUrl = '';

      // Use the environment variable for the API URL
      if (apiUrl.endsWith('/') === true)
        apiUrl = apiUrl.substring(0, apiUrl.length - 1);
      return apiUrl;
    },
    pixelPath() {
      return `${this.pixelUrl}/users/pixel?source=${this.propSource}&ts=${Date.now()}`;
    }
  },
  data() {
    return {}
  }
}

</script>

<template>
  <img :src="pixelPath" class="d-none" alt="1x1"/>
</template>